export default {
  methods: {
    requiredRules() {
      // eslint-disable-next-line eqeqeq
      return v => (!!v && `${v}` != '') || 'This Field is required';
    },
    requiredTimeRules() {
      return v => {
        const splitTime = v.split('~');
        if (splitTime.length < 2) {
          return 'This Field is required';
        }
        const t1 = splitTime[0].trim();
        const t2 = splitTime[1].trim();
        // eslint-disable-next-line eqeqeq
        return ((!!t1 && `${t1}` != '') && (!!t2 && `${t2}` != '')) || 'This Field is required';
      };
    },
    nameRules(n) {
      return v => !v
        || (v && (`${v}`).length <= n)
        || `This Field must be less than ${n} characters`;
    },
    numberRules() {
      return v => !v || (v && /^[0-9]+$/.test(v)) || 'This Field must be number value';
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/CustomRules.js